import type { SectionConfig } from '../lib/types';

export const productSection: SectionConfig = {
  id: 'products.pro', entity: 'product', title: 'Products',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'code', title: 'Code', sortable: true },
    { key: 'price', title: 'Price', type: 'number', sortable: true },
    { key: 'isHardware', title: 'Hardware', type: 'boolean' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'code', title: 'Code', type: 'text' },
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'shortText', title: 'Short Description', type: 'textarea' },
    { key: 'longText', title: 'Full Description', type: 'richtext' },
    { key: 'parameters', title: 'Parameters', type: 'textarea' },
    { key: 'price', title: 'Price (EUR)', type: 'number', required: true },
    { key: 'image', title: 'Main Image', type: 'image' },
    { key: 'model3d', title: '3D Model (.glb)', type: 'file', accept: { 'model/gltf-binary': ['.glb'] } },
    { key: 'model3dPoster', title: '3D Model Preview Image', type: 'image' },
    { key: 'productStatusId', title: 'Status', type: 'select', relation: { entity: 'productStatus', labelField: 'title' } },
    { key: 'categories', title: 'Categories', type: 'multiref', relation: { entity: 'category', labelField: 'title' } },
    { key: 'isHardware', title: 'Is Hardware', type: 'boolean' },
    { key: 'requireSerial', title: 'Require Serial', type: 'boolean' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  childCollections: [
    { entity: 'productImage', title: 'Additional Images', foreignKey: 'productId', kind: 'image' },
    { entity: 'productFile', title: 'Attachments', foreignKey: 'productId', kind: 'file' },
    { entity: 'productVideo', title: 'Videos', foreignKey: 'productId', kind: 'youtube' },
  ],
};

export const categorySection: SectionConfig = {
  id: 'products.cat', entity: 'category', title: 'Categories',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'image', title: 'Image', type: 'image' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'description', title: 'Description', type: 'richtext' },
    { key: 'image', title: 'Image', type: 'image' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const productStatusSection: SectionConfig = {
  id: 'products.pst', entity: 'productStatus', title: 'Product Statuses',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'orderable', title: 'Orderable', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'orderable', title: 'Orderable', type: 'boolean' },
  ],
};

export const downloadSection: SectionConfig = {
  id: 'products.dwn', entity: 'download', title: 'Downloads',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'category', title: 'Category', type: 'number' },
    { key: 'version', title: 'Version' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'productId', title: 'Product', type: 'select', required: true, relation: { entity: 'product', labelField: 'title' } },
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'category', title: 'Category', type: 'select', options: [{ value: 1, label: 'Documents' }, { value: 2, label: 'Software' }] },
    { key: 'file', title: 'File', type: 'file' },
    { key: 'version', title: 'Version', type: 'text' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};
